{
  "baseSpeed": 4.3,
  "speedTolerance": 1.1,
  "inputStepMs": 50,
  "maxStrikes": 10,
  "strikeWindowMs": 60000
}
